export type ValueOf<T> = T[keyof T];

function isIn<K extends string>(
    key: string | number | symbol,
    o: Record<K, unknown>
): key is K {
    return key in o;
}

function assertNever(x: never): never {
    throw new Error(`Unexpected object: ${x}`);
}

/**
 * cast a value to T, with the exception of never. We forbid the cast to never,
 * as nothing should be never. And if so, it should be a compiler error.
 * @param value
 * @returns value as T
 */
const cast = <T>(value: T extends never ? never : unknown): T => value as T;

const TypeUtils = {
    assertNever,
    isIn,
    cast,
};

export default TypeUtils;
